module.exports = __webpack_public_path__ + "assets/img/td4.aa6ab575.png";